import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message,Upload, uploadButton,notification , Switch, Select, Form, Input } from 'antd';
import {LeftCircleOutlined, BorderTopOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import useFetchOrganizationTypes from '../../hooks/fetchOrganizationTypes';
import useFetchCities from '../../hooks/fetchCities';
import useFetchCountries from '../../hooks/fetchCountries';
import useFetchStates from '../../hooks/fetchStates';
import InputMask from 'react-input-mask';

import { app } from '../../config';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
console.log(app);

const Addorganization = () => {
  const { t } = useTranslation(['common']);
  const [phone, setPhone] = useState();
  const [contactPersonPhone, setContactPersonPhone] = useState();
  const [loading, setLoading] = useState(false);
  const [uploadLogo, setuploadLogo] = useState(true);
  const [uploadLogo1, setuploadLogo1] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [imageUrl1, setImageUrl1] = useState();
  const [uploadObj, setUploadObj] = useState({});
  const [uploadedImg, setUploadedImg] = useState('');
  const [uploadedImg1, setUploadedImg1] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [causeAmountPercentage,setcauseAmountPercentage]=useState();
  const [managementFeePercentage,setmanagementFeePercentage]=useState();
  const [addOrgRes, setAddOrgRes] = useState({});
  const [show, setShow] = useState(false); 
  const { TextArea } = Input;
  const token=getTokenfromUserObj();
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  function goBack() {
   navigate('/organizations/listall',{replace:true});
  }
  window.addEventListener('popstate', goBack);
const handleuploadChange = (info) => {
  if (info.file.status === 'uploading') {
    setLoading(true);
    return;
  }
  if (info.file.status === 'done') {
    // Get this url from response in real world.
    info.file?console.log(info.file.response.data.Location):console.log("Not found"); 
    info.file?setUploadedImg(info.file.response.data.Location):" "
    getBase64(info.file.originFileObj, (url) => {
      setLoading(false);
      setuploadLogo(false);
      setImageUrl(url);
    });
  }
};
const handleuploadChange2 = (info) => {
  if (info.file.status === 'uploading') {
    setLoading1(true);
    return;
  }
  if (info.file.status === 'done') {
    // Get this url from response in real world.
    info.file?console.log(info.file.response.data.Location):console.log("Not found"); 
    info.file?setUploadedImg1(info.file.response.data.Location):" "
    getBase64(info.file.originFileObj, (url) => {
      setLoading1(false);
      setuploadLogo1(false);
      setImageUrl1(url);
    });
  }
};
const beforeUpload = (file) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }t
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
};
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  let navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem('user'));
  console.log(user);
  let orgTypeRes = useFetchOrganizationTypes();
  console.log(orgTypeRes);
  let orgTypes = orgTypeRes.response ? orgTypeRes.response.data : [];
  console.log(orgTypes);
  const countriesRes = useFetchCountries();
  const countries = countriesRes.response ? countriesRes.response.data : [];
  console.log(countries);
  const statesResp = useFetchStates();
  const states = statesResp.response ? statesResp.response.data : [];
  console.log(states);
  const headers={auth:token}
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
 
  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/org/addorg`, uploadObj,{headers:{auth:token}});
      if(res.data.statusCode === 200){
        setAddOrgRes(res.data)
        setTimeout(()=>{navigate('/organizations/listall')},1000)
      }
      // window.alert(res.data.message);
      // if (res.data.statusCode === 200) navigate('/organizations/listall');
    } catch (err) {
      console.log(err);
      err?console.log(err.response.data):" ";
      if (err)setAddOrgRes(err.response.data);
      // else retrun;
    }
  };
  const handleChange = (event) => {
    setPhone(event.target.value);
    // handle phone number input here
  };
  const handleContactPersonChange = (event) => {
    setContactPersonPhone(event.target.value);
    // handle phone number input here
  };

  
  const onFinish = (values) => {
    console.log('Success:', values);
    setAddOrgRes({})
    setUploadObj({
      regNumber: values.regNumber ? values.regNumber : ' ',
      organizationName: values.organizationName ? values.organizationName : null,
      organizationLogo: uploadedImg ? uploadedImg : ' ',
      image: uploadedImg1 ? uploadedImg1 : ' ',
      email: values.email ? values.email : '',
      phone: phone ? phone : '',
      contactPerson:values.contactPerson?values.contactPerson:" ",
      contactPersonPhone:contactPersonPhone?contactPersonPhone:" ",
      contactPersonEmail:values.contactPersonEmail?values.contactPersonEmail:" ",
      organizationType: values.organizationType ? values.organizationType : '',
      outletName: values.outletName ? values.outletName : null,
      address: values.address ? values.address : null,
      city: values.city ? values.city : null,
      cityId: values.cityId ? values.cityId : null,
      stateId: values.state ? values.state : null,
      countryId: values.country ? values.country : null,
      longitude: values.longitude ? values.longitude : '',
      showAmountBreakup:values.showAmountBreakup?values.showAmountBreakup:null,
      causeAmountPercentage:values.causeAmountPercentage ? Number(values.causeAmountPercentage.split('%')[0])/100:null,
      managementFeePercentage:values.managementFeePercentage ?Number(values.managementFeePercentage.split('%')[0].split('_')[0])/100:null,
      latitude: values.latitude ? values.latitude : '',
      azanTimeMethod:values.azanTimeMethod?values.azanTimeMethod:0,
      fiqa:values.fiqa ? values.fiqa :0,
      isActive: values.isActive === true ? 1 : 0,
      description: values.description ? values.description : '',
      createdByUserId: user.userId,
    });
    setShow(true);
  };
  console.log(uploadObj);

  const submitData=()=>{
    console.log('calling')  
    if (Object.keys(uploadObj).length > 0) {
      console.log(phone,contactPersonPhone)
      if(phone.split("_")[0].length<14||contactPersonPhone.split("_")[0].length<14){
        setShow(false);
        message.error('Invalid mobile number')
        return;
      }
          uploadData(uploadObj);
  }
}
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const c = useFetchCauseCategories();
  console.log(c);
  let causes = c ? c.response : [];
  console.log(causes);
  console.log(addOrgRes);
  const renderList = []; //For testing purposes
  return (
    
    <div class='container'>
      {/* <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"></link> */}
      <div class='row mt-4 w-75 tbl'>
        <div class="row topbar " style={{height:"70px"}}>
        <div class='col-lg-4 fs-3 fw-bold'>
        {' '}
        <LeftCircleOutlined onClick={()=>{navigate('/organizations/listall')}} className='mt-3 ml-4 back-icon' style={{ fontSize: '38px'}} />
      </div>
        <div class='col-lg-7 fs-3 fw-bold '>
        <h2 class=' mb-5 mt-4 fw-bold text-white fs-4'> {t('Add Organization')} </h2>
        </div>
          {' '}
        </div>
        <div class='col mb-5 mt-4 w-50'>
          <div class='col-lg-9 align-self-center mt-2 mb-4'>
            <Form
              name='basic'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                maxWidth: 600,
              }}
              initialValues={{
                remember: true,
                ['id']: 1,
                ['country']: 6,
                ['isActive']: true,
                ['showAmountBreakup']: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              <Form.Item
                label='Registration / Tax ID'
                name='regNumber'
                
                defaultValue='1'
                colon={false}
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Input className='input-width' placeholder="Registration / Tax ID" />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Organization Name'
                name='organizationName'
                rules={[
                  {
                    required: true,
                    message: 'Input Organization name',
                  },
                ]}
              >
                <Input placeholder="Enter Organization Name" />
              </Form.Item>
              <Form.Item label='Logo'   colon={false}  name='image'>
            <Upload
              // name="avatar"
              listType='picture-card'
              className='avatar-uploader'
              showUploadList={false}

              action={`${app.URL}/upload/orglogo`}

              // action={`${app.URL}/api/upload/orglogo`}

              headers={headers}
              beforeUpload={beforeUpload}
              onChange={handleuploadChange}
            >
              {/* {imageUrl ? (
                <img
                  src={imageUrl}
                  alt='avatar'
                  style={{
                    width: '100%',
                  }}
                />
              ) : (
                uploadButton
              )} */}
                {uploadLogo ? 
              loading?uploadButton:uploadButton
              : (
                <img
                  src={imageUrl}
                  alt='avatar'
                  style={{
                    width: '100%',
                  }}
                />
              ) }
            </Upload>
          </Form.Item>
          <Form.Item label='Image'   colon={false}  name='image2'>
            <Upload
              // name="avatar"
              listType='picture-card'
              className='avatar-uploader'
              showUploadList={false}

              action={`${app.URL}/upload/orgimage`}

              // action={`${app.URL}/api/upload/orgimage`}

              headers={headers}
              beforeUpload={beforeUpload}
              onChange={handleuploadChange2}
            >
       {uploadLogo1 ? 
              loading1?uploadButton:uploadButton
              : (
                <img
                  src={imageUrl1}
                  alt='avatar'
                  style={{
                    width: '100%',
                  }}
                />
              ) }
            </Upload>
          </Form.Item>
              <Form.Item
                colon={false}
                label='Organization Type'
                name='organizationType'
                rules={[
                  {
                    required: true,
                    message: 'Select Org type',
                  },
                ]}
              >
                <Select
                  // placeholder = "Select"
                  style={{
                    width: 280,
                  }}
                  placeholder='Select Organization Type'
                >
                  {orgTypes.map((type) => {
                    return (
                      <Option key={type.organizationTypeId} value={type.organizationTypeId}>
                        {type.organizationType}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>

              {/* Outlet Name */}
              <Form.Item
                label='Description'
                name='outletName'
                colon={false}
                rules={[
                  {
                    required: false,
                    message: 'Please enter outlet name',
                  },
                ]}
              >
                <Input placeholder="Enter Description" />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Email'
                name='email'
                type='email'
                rules={[
                  {
                    type: 'email',
                    required: true,
                    message: 'Input Email',
                  },
                ]}
              >
                <Input placeholder="Enter Email" />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Phone'
                name='phone'
                rules={[
                  {
                    required: true,
                    message: 'Input Phone',
                  },
                ]}
              >
                <InputMask mask='(999) 999-9999' onChange={handleChange}>
                  {(inputProps) => <Input {...inputProps} placeholder='Enter Phone Number' />}
                  {/* <Input /> */}
                </InputMask>
                {/* <Input /> */}
                {/* <MaskedInput mask={"(999) 999-9999"}  placeholder="mm/yyyy"/> */}
              </Form.Item>
              {/* Select box for cause category */}

              {/* Select box for organization */}
              <Form.Item
                label='Address'
                name='address'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: 'Input address',
                  },
                ]}
              >
                <Input placeholder="Enter Address"/>
              </Form.Item>

              {/* City */}
              {/* <Form.Item
                    colon={false}
                    label='City'
                    name='city'
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      listHeight={250}
                      listItemHeight={500}
                      style={{
                        width: 150,
                      }}
                      placeholder="Select"
                    >
                      {cities.map((city) => {
                        return (
                          <Option key={city.cityId} value={city.cityId}>
                            {city.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item> */}
                         <Form.Item
                colon={false}
                label='Country'
                name='country'
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Select
                  listHeight={250}
                  listItemHeight={500}
                  disabled={true}
                  style={{
                    width: 280,
                  }}
                  placeholder='Select'
                >
                  {countries.map((country) => {
                    return (
                      <Option key={country.countryId} value={country.countryId}>
                        {country.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              {/* State */}
              <Form.Item
                colon={false}
                label='State'
                name='state'
                rules={[
                  {
                    required: true,
                    message: 'Select state',
                  },
                ]}
              >
                <Select
                  listHeight={250}
                  listItemHeight={500}
                  style={{
                    width: 280,
                  }}
                  placeholder='Select State'
                >
                  {states.map((state) => {
                    return (
                      <Option key={state.stateId} value={state.stateId}>
                        {state.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              {/*City Input*/}
              <Form.Item
                label='City'
                name='city'
                colon={false}
                rules={[
                  {
                    required: false,
                    message: 'Please input your address!',
                  },
                ]}
              >
                <Input style={{ width: 150 }} placeholder="Enter City" />
              </Form.Item>
              <Form.Item
                  colon={false}
                  label='Contact Person Name'
                  name='contactPerson'
                  rules={[
                    {
                      required: true,
                      message: 'Enter Contact Person Name',
                    },
                  ]}
                >
                  <Input placeholder="Contact Person Name" />
                </Form.Item>
                <Form.Item
                  colon={false}
                  label='Contact Person Phone'
                  name='contactPersonPhone'
                  rules={[
                    {
                      required: true,
                      message: 'Please input Phone!',
                    },
                  ]}
                >
                  <InputMask mask='(999) 999-9999' onChange={handleContactPersonChange}>
                    {(inputProps) => <Input {...inputProps} placeholder='Enter phone number' />}
                    {/* <Input /> */}
                  </InputMask>
                </Form.Item>
                <Form.Item
                  colon={false}
                  label='Contact Person Email'
                  name='contactPersonEmail'
                  type='email'
                  rules={[
                    {
                      type:'email',
                      required: true,
                      message: 'Enter Contact Person Email',
                    },
                  ]}
                >
                  <Input placeholder="Contact Person Email" />
                </Form.Item>
              <Form.Item label='Show Amount Breakup' colon={false} valuePropName='checked' name='showAmountBreakup'>
                <Switch />
              </Form.Item>
              <Form.Item
                label='Cause Amount Percentage'
                name='causeAmountPercentage'
                colon={false}
                rules={[
                  {
                    required: false,
                    message: 'Input address',
                  },
                ]}
              >
             <InputMask mask='99%' onChange={(e)=>{setcauseAmountPercentage(e.target.value)}}>
                  {(inputProps) => <Input {...inputProps} placeholder='Enter Cause Amount %' />}
                  {/* <Input /> */}
                </InputMask>
              </Form.Item>

              <Form.Item
                label='Management Fee Percentage'
                name='managementFeePercentage'
                colon={false}
                rules={[
                  {
                    required: false,
                    message: 'Input address',
                  },
                ]}
              >
               <InputMask mask='99%' onChange={(e)=>{setmanagementFeePercentage (e.target.value)}}>
                  {(inputProps) => <Input {...inputProps} placeholder='Enter Cause Amount %' />}
                  {/* <Input /> */}
                </InputMask>
              </Form.Item>

              {/* Country */}
       
              <Form.Item
                    colon={false}
                    label='Longitude'
                    name='longitude'
                    rules={[
                      {
                        required: true,
                        message: 'Please input longitude',
                      },
                    ]}
                  >
                    <Input placeholder='Enter longitude' />
                  </Form.Item>
                  <Form.Item
                    colon={false}
                    label='Latitude'
                    name='latitude'
                    rules={[
                      {
                        required: true,
                        message: 'Please input latitude',
                      },
                    ]}
                  >
                    <Input placeholder='Enter latitude'/>
                  </Form.Item>
                  <Form.Item
                colon={false}
                label='Azan Timing Method'
                name='azanTimeMethod'
                rules={[
                  {
                    required: true,
                    message: 'Please select azan time method',
                  },
                ]}
              >
                <Select
                  listHeight={250}
                  listItemHeight={500}  
                  style={{
                    width: 280,
                  }}
                  placeholder='Select method'
                >
                      <Option key={0} value={0}>
                      Shia Ithna-Ansari
                      </Option>
                      <Option key={1} value={1}>
                      University of Islamic Sciences, Karachi
                      </Option>
                      <Option key={2} value={2}>
                      Islamic Society of North America
                      </Option>
                      <Option key={3} value={3}>
                      Muslim World League
                      </Option>
                      <Option key={4} value={4}>
                      Umm Al-Qura University, Makkah
                      </Option>
                      <Option key={5} value={5}>
                      Egyptian General Authority of Survey
                      </Option>
                      <Option key={7} value={7}>
                      Institute of Geophysics, University of Tehran
                      </Option>
                      <Option key={8} value={8}>
                      Gulf Region
                      </Option>
                      <Option key={9} value={9}>
                      Kuwait
                      </Option>
                      <Option key={10} value={10}>
                      Qatar
                      </Option>
                      <Option key={11} value={11}>
                      Majlis Ugama Islam Singapura, Singapore
                      </Option>
                      <Option key={12} value={12}>
                      Union Organization islamic de France
                      </Option>
                      <Option key={13} value={13}>
                      Diyanet İşleri Başkanlığı, Turkey
                      </Option>
                      <Option key={14} value={14}>
                      Spiritual Administration of Muslims of Russia
                      </Option>
                      <Option key={16} value={16}>
                      Dubai (unofficial)
                      </Option>
                </Select>
              </Form.Item>
              <Form.Item
                colon={false}
                label='Fiqa'
                name='fiqa'
                rules={[
                  {
                    required: true,
                    message: 'Please select fiqa',
                  },
                ]}
              >
                <Select
                  listHeight={250}
                  listItemHeight={500}  
                  style={{
                    width: 280,
                  }}
                  placeholder='Select fiqa'
                >
                      <Option key={0} value={0}>
                      Shafi
                      </Option>
                      <Option key={1} value={1}>
                      Hanafi
                      </Option>
                </Select>
              </Form.Item>
              <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                <Switch />
              </Form.Item>
              {/* <Form.Item
                label='About organization'
                name='description'
                colon={false}
                rules={[
                  {
                    message: 'Please input your password!',
                  },
                ]}
              >
                <TextArea rows={4} />
              </Form.Item> */}

              <Form.Item
                colon={false}
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                   {/* <div
      className="modal show"
      style={{ display: 'block', position: 'initial' }}
    >
      <Modal.Dialog>
        <Modal.Header closeButton>
          <Modal.Title>Modal title</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Modal body text goes here.</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary">Close</Button>
          <Button variant="primary">Save changes</Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div> */}
      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}

     {addOrgRes.statusCode===200? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addOrgRes.message}</Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={()=>{navigate('/organizations/listall')}}>
            Close
          </Button> */}
          {/* <Button variant="primary"  htmlType='submit' onClick={submitData}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>:addOrgRes.statusCode===400? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Failed</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addOrgRes.data.message}</Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal> : <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body >Are you sure you want to add organization?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary"  htmlType='submit' onClick={submitData}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>}

                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                  Save
                </button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addorganization;
